import * as React from 'react';
import type { SVGProps } from 'react';
const SvgUploadFileInactive = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 172 132"
    {...props}
  >
    <path
      fill="#FEFEFE"
      fillRule="evenodd"
      stroke="#CBCCD7"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={22.926}
      strokeWidth={1.013}
      d="m103.322 10.088 46.679 12.444L169 55.256 149.086 129.2a2.44 2.44 0 0 1-2.996 1.711l-70.282-18.735a2.41 2.41 0 0 1-1.72-2.98l26.238-97.398c.333-1.297 1.692-2.07 2.996-1.711"
      clipRule="evenodd"
    />
    <path
      fill="#DCDDE6"
      fillRule="evenodd"
      d="M166.41 101.906c.057-.687.086-1.031-.029-1.346-.115-.257-.373-.515-.603-.658-.316-.172-.69-.172-1.465-.172h-17.552c-.747 0-1.149 0-1.437-.143a1.53 1.53 0 0 1-.603-.6c-.144-.287-.144-.688-.144-1.46V80.064c0-.773 0-1.145-.172-1.46-.144-.23-.402-.487-.661-.601-.316-.115-.66-.086-1.35-.029-3.562.372-7.009 1.575-9.997 3.578a21.8 21.8 0 0 0-8.072 9.819 21.83 21.83 0 0 0-1.264 12.623 22.16 22.16 0 0 0 6.004 11.193 22.3 22.3 0 0 0 11.232 5.983c4.252.83 8.676.4 12.669-1.26 4.021-1.66 7.44-4.437 9.853-8.044 2.011-2.977 3.217-6.412 3.591-9.961"
      clipRule="evenodd"
    />
    <path
      fill="#A9AABC"
      fillRule="evenodd"
      d="M171.953 92.03a21.9 21.9 0 0 0-6.32-13.282 22.05 22.05 0 0 0-13.329-6.297c-.689-.058-1.034-.086-1.35.057-.258.086-.517.343-.661.6-.172.287-.172.688-.172 1.432v17.49c0 .744 0 1.145.144 1.431q.214.386.603.602c.287.143.661.143 1.436.143h17.552c.747 0 1.149 0 1.437-.172.258-.143.488-.4.603-.659.143-.314.115-.658.057-1.345"
      clipRule="evenodd"
    />
    <path
      fill="#FEFEFE"
      fillRule="evenodd"
      stroke="#CBCCD7"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={22.926}
      strokeWidth={1.013}
      d="M8.783 30.265 54.845 18l32.44 18.629 19.639 72.882c.328 1.278-.438 2.611-1.723 2.937l-69.284 18.465c-1.286.354-2.626-.408-2.954-1.686L7.087 33.229c-.355-1.278.41-2.61 1.696-2.964"
      clipRule="evenodd"
    />
    <path
      fill="#DCDDE6"
      fillRule="evenodd"
      d="M48.429 86.935c3.533-.945 5.285-1.403 6.463-2.462a6.55 6.55 0 0 0 2.011-3.463c.316-1.518-.172-3.292-1.092-6.813l-4.74-17.548c-.947-3.52-1.407-5.267-2.47-6.44a6.6 6.6 0 0 0-3.476-2.004c-1.522-.315-3.303.143-6.808 1.088L8.557 57.25c-3.505.944-5.287 1.402-6.436 2.433a6.55 6.55 0 0 0-2.01 3.492c-.345 1.517.143 3.292 1.091 6.784l4.711 17.576c.948 3.492 1.408 5.267 2.47 6.412a6.4 6.4 0 0 0 3.477 2.004c1.522.343 3.303-.143 6.837-1.088z"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M14.243 72.536c2.327-.63 3.706-3.005 3.074-5.295-.603-2.319-2.988-3.693-5.315-3.063a4.294 4.294 0 0 0-3.073 5.295c.632 2.319 2.987 3.664 5.314 3.063"
      clipRule="evenodd"
    />
    <path
      fill="#9394A5"
      fillRule="evenodd"
      d="M56.903 81.01c.316-1.518-.173-3.293-1.092-6.813l-.632-2.32-14.076-8.1c-1.982-1.145-4.568-.458-5.717 1.517L18.352 94.692l22.062-5.61 8.014-2.147c3.534-.945 5.286-1.403 6.464-2.462a6.55 6.55 0 0 0 2.01-3.464"
      clipRule="evenodd"
    />
    <path
      fill="#A9AABC"
      fillRule="evenodd"
      d="m18.697 94.864 21.717-5.782-18.93-10.906c-2.011-1.145-4.568-.458-5.717 1.517l-7.9 13.597c.173.257.316.458.517.658a6.4 6.4 0 0 0 3.476 2.004c1.523.343 3.304-.143 6.837-1.088M150.288 22l-6.201 23.65a2.45 2.45 0 0 0 1.694 3.006L169 55z"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      stroke="#CBCCD7"
      d="M50.727.5h49.921l27.571 27.474v79.342c0 1.096-.923 2.019-2.028 2.019H50.727c-1.137 0-2.057-.926-2.057-2.019V2.519c0-1.093.92-2.019 2.057-2.019Z"
    />
    <path
      fill="#787887"
      fillRule="evenodd"
      d="M113.265 65.122c-5.143 1.203-9.308 3.464-12.41 6.756-3.132 3.32-5.286 7.7-6.406 13.168-.115.458-.546.744-.977.658a.83.83 0 0 1-.603-.658c-1.15-5.497-3.304-9.905-6.435-13.197-3.131-3.32-7.268-5.553-12.381-6.727-.46-.114-.718-.572-.632-1.03.086-.344.344-.601.66-.658 5.142-1.231 9.308-3.493 12.44-6.813 3.102-3.292 5.227-7.643 6.348-13.11a.81.81 0 0 1 .948-.659c.344.086.574.372.632.716 1.149 5.438 3.303 9.818 6.434 13.139 3.103 3.291 7.239 5.553 12.382 6.727.43.114.718.572.631 1.03a.87.87 0 0 1-.631.658M87.209 27.165q-5.429 1.203-8.704 4.466t-4.481 8.673a.525.525 0 0 1-.661.401c-.23-.029-.374-.2-.431-.4-.804-3.636-2.298-6.527-4.481-8.703-2.212-2.175-5.085-3.635-8.676-4.437-.316-.057-.517-.343-.43-.658.028-.23.229-.4.459-.43 3.59-.83 6.492-2.318 8.704-4.494 2.154-2.175 3.648-5.038 4.424-8.616a.575.575 0 0 1 .66-.458.66.66 0 0 1 .46.487c.805 3.578 2.298 6.47 4.482 8.645 2.183 2.175 5.055 3.664 8.675 4.437a.56.56 0 0 1 .43.658c-.056.229-.229.4-.43.43"
      clipRule="evenodd"
    />
    <path
      fill="#454655"
      fillOpacity={0.1}
      fillRule="evenodd"
      d="M75.574 0h25.28l27.864 27.767v79.549c0 1.374-1.149 2.519-2.528 2.519h-24.877z"
      clipRule="evenodd"
    />
    <path
      fill="#A9AABC"
      fillRule="evenodd"
      d="M100.854 0v25.219a2.56 2.56 0 0 0 2.556 2.547h25.308zM42.424 75.456h33.84c1.379 0 2.528 1.202 2.528 2.69v13.226c0 1.46-1.15 2.69-2.528 2.69h-33.84c-1.408 0-2.557-1.202-2.557-2.69V78.147c0-1.489 1.15-2.69 2.557-2.69"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgUploadFileInactive;
